module.exports = __webpack_public_path__ + "img/blue-fox.3af702e0.webp";